/* NÛMA homepage — fade-in bij scrollen + carrouselbediening (pijlen en voortgangsbalk). */
(function () {
  if (window.__numaHome) return;
  window.__numaHome = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  function reveal(root) {
    var scope = root || document;
    var items = scope.querySelectorAll('[data-numa-reveal]:not(.is-visible)');
    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    }
    var vh = window.innerHeight;
    items.forEach(function (el) {
      // Wat al in beeld staat direct tonen, zodat er niets knippert.
      if (el.getBoundingClientRect().top < vh) {
        el.classList.add('is-visible');
      } else {
        observer.observe(el);
      }
    });
  }

  function initRail(section) {
    if (section.dataset.numaRailReady) return;
    var track = section.querySelector('.numa-rail__track');
    if (!track) return;
    section.dataset.numaRailReady = 'true';
    var bar = section.querySelector('.numa-rail__progress span');
    var prev = section.querySelector('[data-numa-step="-1"]');
    var next = section.querySelector('[data-numa-step="1"]');

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (bar) {
        var ratio = track.scrollWidth > 0 ? track.clientWidth / track.scrollWidth : 1;
        var width = Math.min(100, Math.max(12, ratio * 100));
        var offset = max > 0 ? (track.scrollLeft / max) * (100 - width) : 0;
        if (document.dir === 'rtl') offset = max > 0 ? (Math.abs(track.scrollLeft) / max) * (100 - width) : 0;
        bar.style.width = width + '%';
        bar.style.marginInlineStart = offset + '%';
        bar.parentElement.hidden = max <= 2;
      }
      if (prev) prev.disabled = Math.abs(track.scrollLeft) <= 2;
      if (next) next.disabled = Math.abs(track.scrollLeft) >= max - 2;
    }

    function step(dir) {
      var card = track.firstElementChild;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 20;
      var amount = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      track.scrollBy({ left: dir * amount, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initVideos(root) {
    (root || document).querySelectorAll('.numa-video video').forEach(function (video) {
      video.muted = true;
      video.setAttribute('playsinline', '');
      if (reduceMotion) {
        video.removeAttribute('autoplay');
        video.pause();
        return;
      }
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    });
  }

  function init(root) {
    document.documentElement.classList.add('numa-js');
    reveal(root);
    (root || document).querySelectorAll('[data-numa-rail]').forEach(initRail);
    initVideos(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
